export const CONTENT_POSITION_TYPES = {
  headerTop: 'header_top',
  headerBottom: 'header_bottom',
  contentTop: 'content_top',
  contentBottom: 'content_bottom',
  asideTop: 'aside_top',
  asideBottom: 'aside_bottom',
  footerTop: 'footer_top',
  footerBottom: 'footer_bottom',
};

export const CONTENT_TYPES = {
  static: 'static',
  html: 'html',
  menu: 'menu',
};

export const ROUND_THE_CLOCK = 'round-the-clock';

export const NOT_WORK = 'not-work';

export const MIDNIGHT = '00:00';

export const DAYS_OF_WEEK = {
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
  sunday: 0,
};

export const CONTACTS = {
  email: 'support@minfin.com.ua',
};

export const IMAGE_POSITION = {
  cover: 'cover',
  right: 'right',
  top: 'top',
};

export const CONTAINER_CARD_TYPE = {
  big: 'big',
  small: 'small',
};

export const CONTENT_POSITION = {
  bottom: 'bottom',
  right: 'right',
  left: 'left',
  contain: 'contain',
};

export const CURRENCY_UAH = 'uah';
export const CURRENCY_USD = 'usd';
export const CURRENCY_EUR = 'eur';
export const DEFAULT_CURRENCY = CURRENCY_UAH;

export const CURRENCIES = {
  uah: '₴',
  usd: '$',
  eur: '€',
};

export const NEGOTIABLE_PRICE = {
  uk: 'Договірна',
  ru: 'Договорная',
};
